/** Status IDs that require an extra confirmation before applying. */
export const DESTRUCTIVE_ORDER_STATUS_IDS = [3, 4, 5]; // Cancelled, Failed, Refunded

const STATUS_LABELS = {
  1: 'Processing',
  2: 'Completed',
  3: 'Cancelled',
  4: 'Failed',
  5: 'Refunded',
  6: 'Created',
};

const STATUS_COLORS = {
  1: 'primary',   // Processing
  2: 'success',   // Completed
  3: 'error',     // Cancelled
  4: 'error',     // Failed
  5: 'warning',   // Refunded
  6: 'info',      // Created
};

export function getOrderStatusLabel(statusId) {
  // Fallback matches the components' getStatusText default so dialog copy
  // and status chips never disagree on an unmapped status
  return STATUS_LABELS[parseInt(statusId, 10)] || 'New';
}

/**
 * Catalog keys for the customer-facing surfaces. The English labels above stay
 * as they are because the admin panel is deliberately English-only.
 */
const STATUS_LABEL_KEYS = {
  1: 'orders.statusProcessing',
  2: 'orders.statusCompleted',
  3: 'orders.statusCancelled',
  4: 'orders.statusFailed',
  5: 'orders.statusRefunded',
  6: 'orders.statusCreated',
};

export function getOrderStatusLabelKey(statusId) {
  return STATUS_LABEL_KEYS[parseInt(statusId, 10)] || 'orders.statusNew';
}

export function getOrderStatusColor(statusId) {
  return STATUS_COLORS[parseInt(statusId, 10)] || 'default';
}

/** Aliases used by order list/detail components. */
export const getStatusText = getOrderStatusLabel;
export const getStatusColor = getOrderStatusColor;

/**
 * Whether changing order(s) to statusId needs a confirm dialog.
 * Always true for bulk (>1 orders); also true for destructive single updates.
 */
export function needsOrderStatusConfirm(statusId, orderCount = 1) {
  const count = Number(orderCount) || 0;
  if (count > 1) return true;
  return DESTRUCTIVE_ORDER_STATUS_IDS.includes(parseInt(statusId, 10));
}

export function buildOrderStatusConfirmContent(statusId, orderCount) {
  const label = getOrderStatusLabel(statusId);
  return `Change ${orderCount} order(s) to "${label}"? This may affect fulfillment and cannot be easily undone.`;
}
